<template>
  <div>
    <div>
      <article class="box">
        <div class="columns">
          <div class="column">
            <p class="title">
              <span class="has-badge-child-offset2">Documents</span>
              <span v-if="documentCount"
                class="has-badge-rounded has-badge-info has-badge-large"
                :data-badge="documentCount" />

              <a class="button is-secondary is-pulled-right"
                @click="toggleCategoryModal(true)">
                <span class="icon">
                  <i class="mdi mdi-18px mdi-plus" />
                </span>
                <span>Category</span>
              </a>
            </p>
          </div>
        </div>

        <div v-show="isLoading > 0"
          class="columns is-multiline">
          <div class="section">
            <span class="is-loading-image has-text-grey has-text-centered" />
          </div>
        </div>
        <quote-attachment-category-modal :active="modalOpen"
          @cancel="toggleCategoryModal(false)"
          @categories-changed="getQuoteAttachmentCategories()" />
        <template v-show="!isLoading"
          v-for="category in categories">
          <quote-attachment-category :category="category"
            :key="category.quoteAttachmentCategoryId"
            :quote-id="value.quoteId"
            :attachments="category.attachments"
            :categories="categories"
            :max-file-size-mb="maxFileSizeMb"
            @update:attachments="(e)=>handleUpdateAttachments(e)"
            @image-uploaded="getQuoteAttachments()" />
        </template>
      </article>
    </div>
  </div>
</template>

<script>
import QuoteService from './QuoteService'
import { EventHubTypes } from '@/enums'
import QuoteAttachmentCategory from './components/QuoteAttachmentCategory.vue'
import QuoteAttachmentCategoryModal from './components/QuoteAttachmentCategoryModal.vue'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'QuoteDocuments',
  components: {
    QuoteAttachmentCategory,
    QuoteAttachmentCategoryModal
  },
  props: {
    value: null
  },
  data() {
    return {
      categories: [],
      attachments: {},
      isLoading: 0,
      modalOpen: false
    }
  },
  computed: {
    documentCount() {
      return Object.values(this.attachments).reduce((total, row) => total + Object.values(row.quoteAttachments).length, 0)
    },
    maxFileSizeMb() {
      // AudaNet/Bridge quotes cap document uploads at 1.5MB (AudaNet submitFile limit) for shops with
      // AudaNet document upload enabled; everything else keeps the 10MB default
      const audaNetDocumentUploadEnabled = this.$company?.setting?.audaNetDocumentUploadEnabled === true
      return audaNetDocumentUploadEnabled && this.value && (this.value.isAudaNet || this.value.isAudaBridge) ? 1.5 : 10
    }
  },
  created() {
    this.getQuoteAttachmentCategories()
    this.getQuoteAttachments()
    this.$eventHub.$on(EventHubTypes.EntityReloaded, this.getQuoteAttachments)
  },
  beforeDestroy() {
    this.$eventHub.$off(EventHubTypes.EntityReloaded, this.getQuoteAttachments)
  },
  mounted() {},
  methods: {
    handleUpdateAttachments(e) {
      const { category, attachment, isSelected } = e
      let cloned = _cloneDeep(this.categories)
      for (let c of cloned) {
        if (c.quoteAttachmentCategoryId != category.quoteAttachmentCategoryId) continue
        // If select all/deselect all, update all attachments in this category
        if (attachment === 'ALL') {
          for (let a of c.attachments) {
            a.isSelected = isSelected
          }
        } else {
          for (let a of c.attachments) {
            if (a.quoteAttachmentId != attachment.quoteAttachmentId) continue
            a.isSelected = isSelected
            a.orderIndex = attachment.orderIndex
          }
        }
      }
      // Replace array reference for reactivity
      this.categories.splice(0, this.categories.length, ...cloned)
    },
    toggleCategoryModal(value) {
      this.modalOpen = value
    },
    getAttachments(quoteAttachmentCategoryId) {
      return Object.values(Object.values(this.attachments[quoteAttachmentCategoryId]?.quoteAttachments ?? {}))
    },
    sortQuoteAttachments() {
      if (this.categories.length == 0) {
        return
      }

      for (let category of this.categories) {
        let attachments = this.getAttachments(category.quoteAttachmentCategoryId).sort(function (a, b) {
          return a.orderIndex > b.orderIndex
        })
        for (let attachment of attachments) {
          attachment.isSelected = false
        }
        category.attachments = attachments
      }
    },
    async getQuoteAttachmentCategories() {
      this.isLoading += 1
      var response = await QuoteService.getQuoteAttachmentCategories()
      this.categories = response
      this.isLoading -= 1
      this.sortQuoteAttachments()
    },
    async getQuoteAttachments() {
      this.isLoading += 1
      var response = await QuoteService.getQuoteAttachments(this.value.quoteId)
      this.attachments = response.data

      let documentCount = Object.values(this.attachments).reduce((total, row) => total + Object.values(row.quoteAttachments).length, 0)
      this.$eventHub.$emit(EventHubTypes.DocumentCountChanged, documentCount)
      this.isLoading -= 1
      this.sortQuoteAttachments()
    }
  }
}
</script>
